import Stack from '@mui/material/Stack'

import type { StepChartBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import type { BlockProps } from '../../types'

import { variants } from '.'

const StepChartBlock = ({ payload }: BlockProps<StepChartBlockData>) => {
  const {
    instance_slot: { variant },
    instance_slot_data,
  } = payload

  const Variant = variants[variant as keyof typeof variants]

  return (
    <Stack sx={{ p: 16 }}>
      <Variant slotData={instance_slot_data} />
    </Stack>
  )
}

export default StepChartBlock
